import { useEffect } from 'react';
import type { ModalProps } from '~/modal/modalType.enum';
import type { DataLayerId } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';
import { useDataLayersEditViaBTG } from '../useDataLayersEditViaBTG';
import { DataLayerFillEditModalComponent } from './dataLayerFillEditModal.component';

export type DataLayerFillEditModalProps = ModalProps<{
  dataLayerId: DataLayerId;
}>;

export const DataLayerFillEditModalContainer = ({
  dataLayerId,
  ...modalProps
}: DataLayerFillEditModalProps) => {
  const {
    dataLayer,
    boundaryTerritoryGroup,
    updateBoundaryTerritoryGroup,
    onNumberOfRangesChange,
    onSubmit,
  } = useDataLayersEditViaBTG(dataLayerId);

  const onSubmitClick = () => {
    onSubmit();
    modalProps.onClose();
  };

  useEffect(() => {
    if (!dataLayer) {
      modalProps.onClose();
    }
  }, [dataLayer, modalProps]);

  if (!dataLayer || !boundaryTerritoryGroup) {
    return null;
  }

  return (
    <DataLayerFillEditModalComponent
      boundaryTerritoryGroup={boundaryTerritoryGroup}
      onBoundaryTerritoryGroupChange={updateBoundaryTerritoryGroup}
      onNumberOfRangesChange={onNumberOfRangesChange}
      onSubmitClick={onSubmitClick}
      {...modalProps}
    />
  );
};
